const COOKIES = {
  LURKER_ID: 'l_id',
  AB_GROUPS_NAME: 'TestAB_Groups',
  LAST_ADS_SEEN: 'las'
}

function getCookie(name) {
  let cookie

  try {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)

    if (parts.length === 2) {
      cookie = parts.pop().split(';').shift()
    }
  } catch (e) {
    console.log("Failed getting cookie")
  }

  return cookie
}

function getParams() {

  const getValueFromNestedObject = (s, o) =>
    s.reduce((prev, cur) => ((prev && prev[cur]) ? prev[cur] : null), o)

  const queryParams = {}

  queryParams.lurker_id = getCookie(COOKIES.LURKER_ID)

  const las = getCookie(COOKIES.LAST_ADS_SEEN)

  if (las !== null && las !== '' && las !== undefined) {
    queryParams.last_ads_seen = las.split('-').filter( v => !isNaN(v) && v !== null)
  }

  let dataLayer
  try {
    dataLayer = window.dataLayer[0]
  } catch(e) {
    dataLayer = null
  }

  if (dataLayer) {
    queryParams.list_id = getValueFromNestedObject(['page', 'detail', 'list_id'], dataLayer)
    queryParams.region_id = getValueFromNestedObject(['page', 'detail', 'region_id'], dataLayer)
    queryParams.state_id = getValueFromNestedObject(['page', 'detail', 'state_id'], dataLayer)
    queryParams.subcategory_id = getValueFromNestedObject(['page', 'detail', 'category_id'], dataLayer)
    queryParams.category_id = getValueFromNestedObject(['page', 'detail', 'parent_category_id'], dataLayer)
    queryParams.zone_id = getValueFromNestedObject(['page', 'searchDetail', 'subRegionID'], dataLayer)

    return queryParams
  }

  let templateVars
  try {
    templateVars = window.template_vars
  } catch(e) {
    templateVars = null
  }

  if (templateVars) {
    queryParams.list_id = getValueFromNestedObject(['list_id'], templateVars)
    queryParams.region_id = getValueFromNestedObject(['region'], templateVars)
    queryParams.state_id = getValueFromNestedObject(['state'], templateVars)
    queryParams.subcategory_id = getValueFromNestedObject(['category'], templateVars)
    queryParams.zone_id = getValueFromNestedObject(['zone_id'], templateVars)

    return queryParams
  }

  return queryParams
}

function compareObjects(a, b) {
  return (Object.keys(a).map((k) => a[k] === b[k]).concat(Object.keys(b).map((k) => a[k] === b[k]))).reduce((x,y) => x && y)
}

export { getParams, compareObjects }



// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/utils/common.js